"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPaginationRange = getPaginationRange;
var MAX_VISIBLE_PAGES = 7;
var EDGE_PAGE_COUNT = 5;
function range(start, end) {
    return Array.from({ length: end - start + 1 }, function (_, index) { return start + index; });
}
/**
 * Builds the list of page numbers shown in the table paginator.
 *
 * The first and last pages are always present. When the page count fits within
 * MAX_VISIBLE_PAGES every page is returned. Otherwise the window follows the
 * current page: near the start it shows the first EDGE_PAGE_COUNT pages, near
 * the end it shows the last EDGE_PAGE_COUNT pages, and in the middle it shows
 * the current page with one neighbour on each side. An "ellipsis" entry marks
 * every gap between the window and the first or last page.
 *
 * Callers must pass a page count of at least 1 and a page within 1..pageCount.
 */
function getPaginationRange(page, pageCount) {
    if (pageCount <= MAX_VISIBLE_PAGES) {
        return range(1, pageCount);
    }
    if (page <= EDGE_PAGE_COUNT - 1) {
        return __spreadArray(__spreadArray([], range(1, EDGE_PAGE_COUNT), true), ["ellipsis", pageCount], false);
    }
    if (page >= pageCount - (EDGE_PAGE_COUNT - 2)) {
        return __spreadArray([1, "ellipsis"], range(pageCount - EDGE_PAGE_COUNT + 1, pageCount), true);
    }
    return [1, "ellipsis", page - 1, page, page + 1, "ellipsis", pageCount];
}
